import { getPlatformUrl, getDevdocsUrl } from "./urls";

export interface NavItem {
  name: string;
  path: string;
}

export interface CrossSiteNavItem {
  name: string;
  path: string;
  external: boolean;
}

export const getDefaultNavItems = (): NavItem[] => [
  {
    name: "Bibles",
    path: "/content-library/bibles",
  },
  {
    name: "Dev Docs",
    path: "/overview",
  },
  {
    name: "Community",
    path: "/community",
  },
  {
    name: "Partners",
    path: "/partners",
  },
  {
    name: "Support",
    path: "/support",
  },
];

// Function to get navigation items for the main platform site
export const getPlatformNavItems = (
  devdocsUrl = getDevdocsUrl()
): CrossSiteNavItem[] => {
  const baseItems = getDefaultNavItems();
  return baseItems.map((item) => {
    if (item.name === "Dev Docs") {
      return {
        ...item,
        path: devdocsUrl,
        external: true,
      };
    }
    return {
      ...item,
      external: false,
    };
  });
};

// Function to get navigation items for the devdocs site
export const getDevdocsNavItems = (win?: Window | null): CrossSiteNavItem[] => {
  const baseItems = getDefaultNavItems();
  return baseItems.map((item) => {
    if (item.name === "Dev Docs") {
      return {
        ...item,
        path: "/overview",
        external: false,
      };
    }
    return {
      ...item,
      path: `${getPlatformUrl(win)}${item.path}`,
      external: true,
    };
  });
};

// Function to get navigation items for the bibles site
export const getBiblesNavItems = (): CrossSiteNavItem[] => {
  const baseItems = getDefaultNavItems();
  return baseItems.map((item) => {
    if (item.name === "Dev Docs") {
      return {
        ...item,
        path: `${getDevdocsUrl()}`,
        external: true,
      };
    }
    return {
      ...item,
      path: `${getPlatformUrl()}${item.path}`,
      external: true,
    };
  });
};
